export enum EIMLTypeSubstratVegetal {
    HE = 1,
    HI = 2,
    HF = 3,
    LI = 4,
    BR = 5
}